import { IMeeting } from "@mctypes/meeting.types";
import React from "react";
import { FailedAlert, TodoList } from "../../../../../components";
import { useAppSelector } from "../../../../../hooks";
import {
  useAddAgendaPreperationItemTodoMutation,
  useDeleteAgendaPreperationItemToDoMutation,
  useToggleAgendaPreperationItemTodoMutation,
  useUpdateAgendaPreperationItemToDoMutation,
} from "../../meetingAgendaRTK";

const AgendaPrepTodoItems: React.FC<{
  agendaItem: IMeeting.AgendaItem;
}> = ({ agendaItem }) => {
  const project = useAppSelector((state) => state.adminReducer.project);

  const [addAgendaPrepItemToDo, { isError: addPrepError }] = useAddAgendaPreperationItemTodoMutation();
  const [updateAgendaPropItemToDo, { isError: updatePrepError }] = useUpdateAgendaPreperationItemToDoMutation();
  const [deleteAgendaPrepItemToDo, { isError: deletePrepError }] = useDeleteAgendaPreperationItemToDoMutation();
  const [toggleAgendaPrepItemToDo, { isError: togglePrepError }] = useToggleAgendaPreperationItemTodoMutation();

  const prepItemError = addPrepError || updatePrepError || deletePrepError || togglePrepError;

  return (
    <>
      {prepItemError === true && <FailedAlert />}
      <h5>Forberedelser</h5>
      <TodoList
        todos={agendaItem.todos}
        addNewTodo={async (text) =>
          await addAgendaPrepItemToDo({ projectId: project._id, agendaId: agendaItem._id, text })
        }
        updateTodo={async (_id, text) =>
          await updateAgendaPropItemToDo({ projectId: project._id, agendaId: agendaItem._id, todoId: _id, text })
        }
        deleteTodo={async (_id) =>
          await deleteAgendaPrepItemToDo({ projectId: project._id, agendaId: agendaItem._id, todoId: _id })
        }
        toggleTodo={async (_id, isChecked) =>
          await toggleAgendaPrepItemToDo({
            projectId: project._id,
            agendaId: agendaItem._id,
            todoId: _id,
            isChecked: isChecked,
          })
        }
      />
    </>
  );
};

export default AgendaPrepTodoItems;
